module.exports = "<section>\n    <iframe\n            ng-src=\"{{page.url}}\"\n            class=\"e2e-iframe-untrusted-src\"\n            style=\"width: 100%; height: -webkit-fill-available\"\n            frameborder=\"0\"\n            allowfullscren=\"allowfullscren\"></iframe>\n</section>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/pages/views/ioc_notifications/cyr3con.html
 ** module id = 630
 ** module chunks = 0
 **/